import { render, staticRenderFns } from "./orderDetailEng.vue?vue&type=template&id=87bbdaaa&scoped=true"
import script from "./orderDetailEng.vue?vue&type=script&lang=ts"
export * from "./orderDetailEng.vue?vue&type=script&lang=ts"
import style0 from "./orderDetailEng.vue?vue&type=style&index=0&id=87bbdaaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bbdaaa",
  null
  
)

export default component.exports